// todo:

import { findThumbnail } from '@marketplace-web/shared/utils'

import { UserHandleDto } from '../types/dtos/user-handle'
import { UserSuggestionModel } from '../types/models/user-suggestion'

export const transformUserSuggestion = (user: UserHandleDto): UserSuggestionModel => {
  const { id, login, photo } = user

  return {
    id,
    login,
    thumbnail: findThumbnail(photo),
  }
}

export const transformUserSuggestions = (users: Array<UserHandleDto>): Array<UserSuggestionModel> =>
  users.map(transformUserSuggestion)
